import { Outlet } from 'react-router-dom';
import VnogNavbar from './VnogNavbar';

const VnogLayout = () => (
    <div className="min-h-screen bg-gray-50">
        <VnogNavbar />
        <Outlet />
    </div>
);

export default VnogLayout;
